import { ChangeEvent } from 'react'

import statisticsAnalytics from '~/analytics/statistics/statisticsAnalytics'
import { useAppDispatch, useAppSelector } from '~/redux/hooks'
import { StatisticsFilters } from '~/analytics/statistics/statisticsEvents.types'
import { IUser } from '~/types/user-info-types'

import { selectRewardsStatsFilter, setRewardsTimeFilter } from '../../redux/statistics.slice'
import { CardTimePeriodFilterOptions } from '../../types/profile-card.types'
import SelectOptions from '../SelectOptions'

import RewardsList from './RewardsList'
import UserProfile from './UserProfile'

export default function RewardsCard({ user }: { user?: IUser }): React.ReactElement {
  const dispatch = useAppDispatch()
  const rewardsCardFilter = useAppSelector(selectRewardsStatsFilter)

  const onChangeOption = (e: ChangeEvent<HTMLSelectElement>): void => {
    const { value } = e.target

    statisticsAnalytics.logFilterChange(StatisticsFilters.REWARDS_TAB_TIME, value)
    dispatch(setRewardsTimeFilter(value))
  }

  return (
    <div className="text-center w-full p-2 md:p-4">
      <SelectOptions
        className="w-44"
        onChange={onChangeOption}
        options={CardTimePeriodFilterOptions}
        selectedFilter={rewardsCardFilter}
      />
      <UserProfile familyMember={user} />
      <div className="my-4 w-full h-0.5 bg-purple-light" />
      <RewardsList user={user} />
    </div>
  )
}
